import { Box, Flex } from "@chakra-ui/layout";
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/modal";
import { Image } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import EditableTable from "../../../components/editableTable/EditableTable";
import { verifyCert } from "../../../slice/corporateVerifierHomeSlice";

import { useQueryState, parseAsInteger } from "nuqs";

function CertificatesInfoTable(props) {
  const dispatch = useDispatch();
  const { certificatesInfo } = props;
  const [displayCertImg, setDisplayCertImg] = useState(false);
  const [currentEventName, setCurrentEventName] = useState("");
  const imgSrc = useSelector((state) => state.corporateVerifierHome.imgSrc);
  const [page, setPage] = useQueryState("page", parseAsInteger.withDefault(1));
  const [pageSize, setPageSize] = useQueryState("pageSize", parseAsInteger.withDefault(10));

  const columnOptions = [
    {
      key: "eventName",
      editable: () => false,
      columnName: "Event Name",
    },
    {
      key: "eventYear",
      editable: () => false,
      columnName: "Event Year",
    },
    {
      key: "certificateId",
      editable: () => false,
      columnName: "Certificate ID",
    },
  ];

  const rowOnClick = (rowData) => async () => {
    const { certificateId, eventName } = rowData;
    setCurrentEventName(eventName);
    const res = (await dispatch(verifyCert({ certificateId }))).payload;

    if (res.ok) {
      setDisplayCertImg(true);
    }
  };

  return (
    <Flex align="center" flexDirection="column" w="70%" marginBottom="20px">
      <Modal isOpen={displayCertImg} onClose={() => setDisplayCertImg(false)}>
        <ModalOverlay />
        <ModalContent maxW="56rem">
          <ModalHeader>{currentEventName}</ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" alignItems="center" justifyContent="center">
            <Box w="100%" h="100%" overflow="auto" className="custom-scrollbar">
              <Image w="1000px" src={imgSrc} />
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
      <EditableTable rowOnClick={rowOnClick} tableName="Certificate Search" tableData={certificatesInfo} columnOptions={columnOptions} page={page} pageSize={pageSize} setPage={setPage} setPageSize={setPageSize} />
    </Flex>
  );
}

CertificatesInfoTable.propTypes = {
  certificatesInfo: PropTypes.arrayOf(PropTypes.object),
};

CertificatesInfoTable.defaultProps = {
  certificatesInfo: [],
};

export default CertificatesInfoTable;
